var _config$SEGMENT;

import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.object.keys.js";
import Cookies from 'universal-cookie';
import { AnalyticsBrowser } from '@segment/analytics-next';
import config from '@nerdwallet/app-config';
import { getLogger } from '@nerdwallet/logging';
var segmentLogger = getLogger('SEO-SegmentLibrary');
var analytics = typeof window !== 'undefined' ? new AnalyticsBrowser() : null;
analytics === null || analytics === void 0 ? void 0 : analytics.load({
  writeKey: config === null || config === void 0 ? void 0 : (_config$SEGMENT = config.SEGMENT) === null || _config$SEGMENT === void 0 ? void 0 : _config$SEGMENT.WRITE_KEY
}).catch(function (err) {
  segmentLogger.error(err);
});
var cookies = new Cookies();
export var getCookie = function getCookie(cookieName) {
  return cookies.get(cookieName);
}; // Utility function to convert strings to snake case.
// Empty, null or undefined inputs return an empty string.

export var stringToSnakeCase = function stringToSnakeCase(str) {
  if (str) {
    return str.toLowerCase().replace(/\W+/g, ' ').split(/ |\B(?=[A-Z])/).join('_');
  }

  return '';
};
export var camelToSnakeCase = function camelToSnakeCase(str) {
  return str.replace(/[A-Z]/g, function (letter) {
    return "_".concat(letter.toLowerCase());
  });
}; // Utility function to convert object properties
// from camel case to snake case

export var convertCamelCaseToSnakeCase = function convertCamelCaseToSnakeCase(obj) {
  if (!obj) return obj;
  var snakeCasedObject = {};
  Object.keys(obj).forEach(function (prop) {
    snakeCasedObject[camelToSnakeCase(prop)] = obj[prop];
  });
  return snakeCasedObject;
};
export var getDeployableInfo = function getDeployableInfo() {
  var _config$_meta, _config$_meta2;

  return {
    // eslint-disable-next-line no-underscore-dangle
    deployable_name: config === null || config === void 0 ? void 0 : (_config$_meta = config._meta) === null || _config$_meta === void 0 ? void 0 : _config$_meta.deployable,
    // eslint-disable-next-line no-underscore-dangle
    deployable_version: config === null || config === void 0 ? void 0 : (_config$_meta2 = config._meta) === null || _config$_meta2 === void 0 ? void 0 : _config$_meta2.version
  };
};
export default analytics;